import PersonOutlined from '@mui/icons-material/PersonOutlined';
import { styled } from '@mui/material/styles';

import palette from '../../../../theme/learnerPalette';
import AtomGrid from '../../../atoms/AtomGrid';

export const AvatarContainerStyled = styled(AtomGrid)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const PersonOutlinedIconStyled = styled(PersonOutlined)(({ size }: { size: number }) => ({
  fontSize: size * 0.7,
  color: palette.light.icons.curiousBlue,
}));
